// extracted by mini-css-extract-plugin
export default {"header":"App_header__iBq5i","link":"App_link__fn7cD","button":"App_button__wB7qm","subLink":"App_subLink__RniUq","dropdownFooter":"App_dropdownFooter__lCF5l"};